(function ($) {
  $('.block--advisers').each(function () {
    var maxItem = 1;
    $(window).on("resize", function () {
      var windowWidth = $(window).width();

      if (windowWidth >= 1000) {
        maxItem = 3;
      } else if (windowWidth >= 800) {
        maxItem = 2;
      }
    }).resize();

    var navTab = $(this).find(".nav-tab");
    var carouselCat01Html = $("#tab-cat01 .slider").html();
    var carouselCat02Html = $("#tab-cat02 .slider").html();
    var carouselCat03Html = $("#tab-cat03 .slider").html();
    var settings = {
      init: false,
      watchOverflow: true,
      spaceBetween: 30,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      observer: true,
      observeParents: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
    };

    var carouselInit = $("#tab-cat01").find(".swiper-container");
    var slidesCountInit = carouselInit.find(".swiper-slide").length;
    var mySwiperInit = new Swiper(carouselInit[0], settings);
    mySwiperInit.params.loop = slidesCountInit > maxItem;
    mySwiperInit.params.navigation.nextEl = $("#tab-cat01").find('.custom-button-next')[0];
    mySwiperInit.params.navigation.prevEl = $("#tab-cat01").find('.custom-button-prev')[0];
    mySwiperInit.init();

    navTab.on("click", function (e) {
      e.preventDefault();

      var link = $(this).attr("class").split(' ')[1];
      var target = $(this).attr("href");

      navTab.removeClass('active');
      $(this).addClass('active');

      $(".tab").removeClass('open');
      $(target).addClass('open');

      // Carousel
      var carousel = $(target).find(".swiper-container");

      if (!carousel.hasClass('swiper-container-initialized')) {
        var slidesCount = carousel.find(".swiper-slide").length;
        var mySwiper = new Swiper(carousel[0], settings);
        mySwiper.params.loop = slidesCount > maxItem;
        mySwiper.params.navigation.nextEl = $(target).find('.custom-button-next')[0];
        mySwiper.params.navigation.prevEl = $(target).find('.custom-button-prev')[0];
        mySwiper.init();
      } else {
        if (link == "cat01") {
          $(target).find(".slider").html(carouselCat01Html);
        } else if (link == "cat02") {
          $(target).find(".slider").html(carouselCat02Html);
        } else if (link == "cat03") {
          $(target).find(".slider").html(carouselCat03Html);
        }

        var carouselReload = $(target).find(".swiper-container");
        var slidesCountReload = carouselReload.find(".swiper-slide").length;
        var mySwiperReload = new Swiper(carouselReload[0], settings);
        mySwiperReload.params.loop = slidesCountReload > maxItem;
        mySwiperReload.params.navigation.nextEl = $(target).find('.custom-button-next')[0];
        mySwiperReload.params.navigation.prevEl = $(target).find('.custom-button-prev')[0];
        mySwiperReload.init();
      }
    });
  });
})(jQuery);
